import { ListViewTypeRestrictionType } from '../Behaviors.types';
import { getSelectedTableView } from 'owa-mail-list-store';
import { ReactListViewType } from 'owa-mail-coupon-peek';
import { assertNever } from 'owa-assert';

export const listViewTypeRestrictionType = (
    listViewTypeRestrictionType: ListViewTypeRestrictionType
) => () => {
    const {
        tableQuery: { listViewType },
    } = getSelectedTableView();

    switch (listViewTypeRestrictionType) {
        case ListViewTypeRestrictionType.Message:
            return listViewType == ReactListViewType.Message;

        case ListViewTypeRestrictionType.Conversation:
            return listViewType == ReactListViewType.Conversation;

        default:
            throw assertNever(listViewTypeRestrictionType);
    }
};
